import {
  useLottieAnimation
} from "./chunk-2DTQ5CXV.js";
import "./chunk-D4IWIVYX.js";

// src/index.ts
import React from "react";
var ConfettiAnimation = React.lazy(
  () => import("./confetti-animation.component-LCKUZRZQ.js")
);
export {
  ConfettiAnimation,
  useLottieAnimation
};
//# sourceMappingURL=index.js.map